import type { FederationRuntimePlugin } from '@module-federation/enhanced/runtime';
import type { MFNamesKeys } from '@packages/config/MFNames';
import { appConfig } from '@packages/config/app/app.config';
import type { AppEfrConfig } from '@packages/config/app/app.efr.config';
import type { AppEfrFastConfig } from '@packages/config/app/app.efrFast.config';
import type { AppRekiConfig } from '@packages/config/app/app.reki.config';
import type { AppsServicesKeys } from '@packages/config/app/appsServices';
import type { AppEnvs } from '@packages/config/app/types';
import { appHostMfs } from '@packages/config/appHosts';
import { getCurrentStand } from '@packages/config/utils/getCurrentStand';
import { isHost } from '@packages/config/utils/isHost';

export default function (): FederationRuntimePlugin {
	let remotesUpdated = false;
	return {
		name: 'runtimeMFPlugin',
		beforeInit(args) {
			const mfName = args.origin.name as MFNamesKeys;
			if (isHost(mfName)) {
				const stand = getCurrentStand();

				const appHostConfig:
					| AppEfrConfig
					| AppRekiConfig
					| AppEfrFastConfig = appHostMfs[mfName]
					? appConfig[mfName]
					: appConfig.efr;
				window.getMfLink = (mfLink: MFNamesKeys) =>
					appHostConfig[stand].getMfLink(mfLink);
				window.getMfManifestUrl = (mfLink: MFNamesKeys) =>
					`${appHostConfig[stand].getMfLink(mfLink)}/mf-manifest.json`;
				window.getServiceWorkerInfo = () =>
					appHostConfig[stand].getServiceWorkerInfo();
				window.getApiService = (serviceName: AppsServicesKeys) =>
					appHostConfig[stand].getApiService(serviceName);
				window.getAppEnv = (envName: AppEnvs) =>
					appHostConfig[stand].getAppEnv(envName);
				window.envs = appHostConfig[stand].appEnvs;
				window.rootPath = appHostConfig[stand].rootPath;
				window.baseUrl = appHostConfig[stand].baseUrl;
				window.taskName = appHostConfig[stand].taskName;
			}
			return args;
		},
		beforeRequest(args) {
			if (!remotesUpdated && args.options.remotes.length) {
				for (const remote of args.options.remotes) {
					if ('entry' in remote) {
						remote.entry = window.getMfManifestUrl(
							remote.name as MFNamesKeys,
						);
					}
				}

				remotesUpdated = true;
			}

			return args;
		},
	};
}
